export default "__VITE_ASSET__BcW6evYE__"